<template>
  <div class="endetlawapa">
    <div class="columntitl flex_start">
      <img src="../../../assets/entrust/entrujqicon.png" />
      律师接洽区
    </div>
    <div class="dqwdl" v-if="!istoken">暂无律师接洽</div>
    <div class="ylist" v-else>
      <div class="ylitem flex" v-for="item in 2" :key="item">
        <div class="leflaw">
          <div class="tx">
            <img src="../../../assets/case/aaaa1_sample.png" alt="" />
          </div>
          <div class="xm">王家政律师</div>
          <div class="dh">17356519888</div>
        </div>
        <div class="righd">
          <div class="rcdbts between">
            <div v-if="item % 2 == 1">回复内容仅当事人及本人可见。</div>
            <div v-if="item % 2 == 0">律师回复</div>
            <div class="hftime">回复时间：2021-05-08</div>
          </div>
          <div class="hfnr" v-if="item % 2 == 0">
            可以没问题，依照中户法律法有4892条，这么做这么做，
            可以没问题，依照中户法律法有4892条，这么做这么做，
            可以没问题，依照中户法律法有4892条，这么做这么做，
            可以没问题，依照中户法律法有4892条，这么做这么做，
            可以没问题，依照中户法律法有4892条，这么做这么做，
          </div>
          <div class="lijizxbtn">免费咨询</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      curent: 1, //当前是否是发帖人
    };
  },
  computed: {
    istoken() {
      return this.$store.state.user.token;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.endetlawapa {
  padding: 30px 24px 25px;
  .columntitl {
    font-size: 20px;
    color: #333333;
    img {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
  }
  .dqwdl {
    width: 770px;
    height: 76px;
    margin: 20px auto 0;
    padding: 16px 20px;
    background: #f8f8f8;
    font-size: 16px;
    color: #999999;
  }
  .ylist {
    padding-top: 10px;
    .ylitem {
      margin-top: 20px;
      width: 770px;
      background: #f8f8f8;
      padding: 30px 15px;
      position: relative;
      .leflaw {
        width: 140px;
        text-align: center;
        border-right: 1px solid #eeeeee;
        padding-right: 15px;
        .tx {
          img {
            width: 80px;
            height: 80px;
            border-radius: 50%;
          }
        }
        .xm {
          margin-top: 10px;
          font-size: 16px;
          color: #0465ea;
        }
        .dh {
          margin-top: 10px;
          font-size: 14px;
          color: #666666;
        }
      }
      .righd {
        width: 630px;
        padding-left: 30px;
        .rcdbts {
          font-size: 18px;
          color: #999999;
          .hftime {
            font-size: 14px;
            color: #999999;
          }
        }
        .hfnr {
          margin-top: 10px;
          font-size: 14px;
          color: #999999;
          line-height: 20px;
          height: 80px;
          overflow: hidden;
        }
        .lijizxbtn {
          width: 96px;
          height: 26px;
          line-height: 26px;
          text-align: center;
          background: #2f93fb;
          font-size: 14px;
          color: #ffffff;
          position: absolute;
          bottom: 22px;
          right: 18px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>